// Breadcrumb configuration for NEVXOAULIO VENTURES
const breadcrumbConfig = {
  // Main Pages (flat)
  '/': {
    title: 'Home',
    breadcrumb: [
      { label: 'Home', path: '/' }
    ]
  },
  
  '/about': {
    title: 'About Us',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'About Us', path: '/about' }
    ]
  },
  
  '/contact': {
    title: 'Contact Us',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Contact Us', path: '/contact' }
    ]
  },
  
  '/portfolio': {
    title: 'Our Portfolio',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Portfolio', path: '/portfolio' }
    ]
  },
  
  '/faq': {
    title: 'FAQ',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'FAQ', path: '/faq' }
    ]
  },
  
  '/sitemap': {
    title: 'Sitemap',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Sitemap', path: '/sitemap' }
    ]
  },
  
  // Services Hierarchy
  '/services': {
    title: 'Our Services',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Services', path: '/services' }
    ]
  },
  
  '/services/software-development': {
    title: 'Software Development Services',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Services', path: '/services' },
      { label: 'Software Development', path: '/services/software-development' }
    ]
  },
  
  '/services/cloud-computing': {
    title: 'Cloud Computing Solutions',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Services', path: '/services' },
      { label: 'Cloud Computing', path: '/services/cloud-computing' }
    ]
  },
  
  '/services/cyber-security': {
    title: 'Cyber Security Services',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Services', path: '/services' },
      { label: 'Cyber Security', path: '/services/cyber-security' }
    ]
  },
  
  '/services/vlsi-design': {
    title: 'VLSI Design Services',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Services', path: '/services' },
      { label: 'VLSI Design', path: '/services/vlsi-design' }
    ]
  },
  
  '/services/ai-ml-solutions': {
    title: 'AI & ML Solutions',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Services', path: '/services' },
      { label: 'AI & ML Solutions', path: '/services/ai-ml-solutions' }
    ]
  },
  
  '/services/data-analytics': {
    title: 'Data Analytics Services',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Services', path: '/services' },
      { label: 'Data Analytics', path: '/services/data-analytics' }
    ]
  },
  
  '/services/vlsi': {
    title: 'VLSI Services',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Services', path: '/services' },
      { label: 'VLSI Services', path: '/services/vlsi' }
    ]
  },
  
  '/services/blockchain': {
    title: 'Blockchain & Web3 Solutions',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Services', path: '/services' },
      { label: 'Blockchain & Web3', path: '/services/blockchain' }
    ]
  },
  
  '/services/game-development': {
    title: 'Game Development Services',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Services', path: '/services' },
      { label: 'Game Development', path: '/services/game-development' }
    ]
  },
  
  '/services/ai-automation': {
    title: 'AI Automation Services',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Services', path: '/services' },
      { label: 'AI Automation', path: '/services/ai-automation' }
    ]
  },
  
  '/services/startup-mvp': {
    title: 'Startup MVP Development',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Services', path: '/services' },
      { label: 'Startup MVP', path: '/services/startup-mvp' }
    ]
  },
  
  // Community & Engagement
  '/forum': {
    title: 'Community Forum',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Community', path: '/forum' }
    ]
  },
  
  '/feedback': {
    title: 'Customer Feedback',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Feedback', path: '/feedback' }
    ]
  },
  
  '/blog': {
    title: 'Our Blog',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Blog', path: '/blog' }
    ]
  },
  
  '/careers': {
    title: 'Careers at Nevxoaulio',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Careers', path: '/careers' }
    ]
  },
  
  // User Account
  '/login': {
    title: 'Client Login',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Login', path: '/login' }
    ]
  },
  
  '/signup': {
    title: 'Client Sign Up',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Sign Up', path: '/signup' }
    ]
  },
  
  '/client/dashboard': {
    title: 'Client Dashboard',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Dashboard', path: '/client/dashboard' }
    ]
  },
  
  // Administration
  '/admin/login': {
    title: 'Admin Login',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Admin', path: '/admin/login' }
    ]
  },
  
  '/admin/dashboard': {
    title: 'Admin Dashboard',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Admin', path: '/admin/dashboard' }
    ]
  },
  
  '/admin/analytics': {
    title: 'Analytics Dashboard',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Admin', path: '/admin/dashboard' },
      { label: 'Analytics', path: '/admin/analytics' }
    ]
  },
  
  '/admin/manage-news': {
    title: 'Manage News & Blog',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Admin', path: '/admin/dashboard' },
      { label: 'Manage News', path: '/admin/manage-news' }
    ]
  },
  
  '/admin/manage-feedback': {
    title: 'Manage Feedback',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Admin', path: '/admin/dashboard' },
      { label: 'Manage Feedback', path: '/admin/manage-feedback' }
    ]
  },
  
  '/admin/chat': {
    title: 'Admin Chat Support',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Admin', path: '/admin/dashboard' },
      { label: 'Chat Support', path: '/admin/chat' }
    ]
  },
  
  // Legal
  '/privacy': {
    title: 'Privacy Policy',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Privacy Policy', path: '/privacy' }
    ]
  },
  
  '/terms': {
    title: 'Terms of Service',
    breadcrumb: [
      { label: 'Home', path: '/' },
      { label: 'Terms of Service', path: '/terms' }
    ]
  }
};

// Dynamic route patterns (for blog posts, feedback, etc.)
const dynamicRoutePatterns = {
  '/blog/:id': {
    title: (params) => `Blog: ${params.title || 'Post'}`,
    breadcrumb: (params) => [
      { label: 'Home', path: '/' },
      { label: 'Blog', path: '/blog' },
      { label: params.title || 'Blog Post', path: `/blog/${params.id}` }
    ]
  },
  
  '/feedback/:id': {
    title: (params) => `Feedback #${params.id}`,
    breadcrumb: (params) => [
      { label: 'Home', path: '/' },
      { label: 'Feedback', path: '/feedback' },
      { label: `Feedback #${params.id}`, path: `/feedback/${params.id}` }
    ]
  }
};

// Helper function to get breadcrumb for any route
export const getBreadcrumbConfig = (path, dynamicParams = {}) => {
  // Check dynamic routes first
  for (const [pattern, config] of Object.entries(dynamicRoutePatterns)) {
    const regex = new RegExp(`^${pattern.replace(/:[^\s/]+/g, '([\\w-]+)')}$`);
    const match = path.match(regex);
    
    if (match) {
      const params = { ...dynamicParams, id: match[1] };
      return {
        title: typeof config.title === 'function' ? config.title(params) : config.title,
        breadcrumb: typeof config.breadcrumb === 'function' 
          ? config.breadcrumb(params) 
          : config.breadcrumb
      };
    }
  }
  
  // Check static routes
  if (breadcrumbConfig[path]) {
    return breadcrumbConfig[path];
  }
  
  // Fallback for unknown routes
  const segments = path.split('/').filter(segment => segment);
  const breadcrumb = [{ label: 'Home', path: '/' }];
  
  let currentPath = '';
  segments.forEach((segment, index) => {
    currentPath += `/${segment}`;
    const isLast = index === segments.length - 1;
    
    // Convert kebab-case to Title Case
    const label = segment
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
    
    breadcrumb.push({
      label,
      path: isLast ? path : currentPath
    });
  });
  
  return {
    title: breadcrumb[breadcrumb.length - 1].label,
    breadcrumb
  };
};

// Generate JSON-LD structured data
export const generateBreadcrumbSchema = (breadcrumb) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumb.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.label,
      "item": `https://nevxoaulio.com${item.path}`
    }))
  };
};

export default breadcrumbConfig;